/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_13fdc916"]'><cube-button disabled>置灰态</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_13fdc916"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_13fdc916"}
  /** script content **/
  require("./btn-disabled.mpx.js?isComponent&outputPath=components%2Fbtn-disabled13fdc916%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-disabled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-disabled13fdc916%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_13fdc916"],
    ctorType: "component",
    outputPath: "components/btn-disabled13fdc916/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>